module.exports = __webpack_public_path__ + "img/index_icon_selected.2396545f.png";